import React, { useEffect, memo, useCallback, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import {
  gameCDKSetVisible,
  gameCdkQRcodeGet,
  gameCdkPollsResult,
  gameCDKGetDesc,
} from '../../actions/gamecdk';
import { logging } from '../../actions/log';
import styles from './Gamecdk.module.less';
import { logNative, changeClass } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectGameCDK = createSelector(
  state => state.gamecdk,
  gamecdk => gamecdk,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

let GameCDKPayTimeoutIndex = 0; // 用于循环查询支付后，获取cdk码
let GameCDKQRCodeTimeIndex = 0; // 用于避免多次请求接口
export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { gamecdkVisible, gamecdkQRcode, gamecdkPolls, gamecdkDesc } = useSelector(selectGameCDK); // 展示iframe
  const userInfo = useSelector(selectUserInfo);

  const [pageTime, setPageTime] = useState(false); // 页面加载态是否时间到了
  const [pageState, setPageState] = useState(1); // 页面状态    1: 加载  2: 支付   3: 获取cdk成功  4: 失败
  const iframeOrderRef = useRef(null);
  const iframeCodeRef = useRef(null);

  const loadRef = useRef(null);
  const orderRef = useRef(null);
  const codeRef = useRef(null);
  const errorRef = useRef(null);

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Shop_Mall',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(gameCDKGetDesc());
  }, []);

  useEffect(() => {
    if (pageState === 1) {
      setTimeout(() => {
        setPageTime(true);
      }, 500);
    }
  }, [pageState]);

  // 控制展示哪一个页面
  useEffect(() => {
    if (checkPage()) {
      pageState === 1 && showPage('load');
      pageState === 2 && showPage('order');
      pageState === 3 && showPage('code');
      pageState === 4 && showPage('error');
    }
  }, [pageState, loadRef, orderRef, codeRef, errorRef]);

  useEffect(() => {
    if (
      pageTime &&
      gamecdkQRcode?.loading === 3 &&
      gamecdkQRcode?.code === 10000 &&
      gamecdkQRcode?.data?.url
    ) {
      setPageState(2);
    } else if (pageTime && gamecdkQRcode?.loading === 4) {
      showPage('error');
      setPageState(4);
    }
  }, [gamecdkQRcode, pageTime]);

  // 创建订单
  useEffect(() => {
    if (userInfo && userInfo?.st && gamecdkVisible.isShow && gamecdkVisible?.soft) {
      clearTimeout(GameCDKQRCodeTimeIndex);
      GameCDKQRCodeTimeIndex = setTimeout(() => {
        clearTimeout(GameCDKQRCodeTimeIndex);
        getGameCdkQRcode();
      }, 500);
    }
  }, [gamecdkVisible, logInfoData, userInfo]);

  // 定时查询是否支付成功
  useEffect(() => {
    if (
      !(
        pageTime &&
        gamecdkQRcode?.loading === 3 &&
        gamecdkQRcode?.code === 10000 &&
        gamecdkQRcode?.data?.url
      )
    ) {
      return;
    }
    // 页面状态    1: 加载  2: 支付   3: 获取cdk成功  4: 失败
    clearTimeout(GameCDKPayTimeoutIndex);
    GameCDKPayTimeoutIndex = setTimeout(() => {
      if (
        gamecdkPolls?.code === 10000 &&
        gamecdkPolls?.data?.code &&
        gamecdkPolls?.data?.exchangeUrl
      ) {
        setPageState(3);
        clearTimeout(GameCDKPayTimeoutIndex);
      } else {
        getGameCdkPolls();
        clearTimeout(GameCDKPayTimeoutIndex);
      }
    }, 4000);
  }, [pageTime, gamecdkQRcode, gamecdkPolls]);

  const getGameCdkQRcode = useCallback(() => {
    try {
      if (
        gamecdkVisible?.soft &&
        '' + gamecdkVisible?.soft?.gameCdkPrice &&
        '' + gamecdkVisible?.soft?.gameCdkSid
      ) {
        dispatch(
          gameCdkQRcodeGet({
            price: gamecdkVisible?.soft?.gameCdkPrice,
            sid: gamecdkVisible?.soft?.gameCdkSid,
            chan: logInfoData?.source || 'GameCdk_Err',
          }),
        );
      }
    } catch (error) {}
  }, [gamecdkVisible, logInfoData]);

  const getGameCdkChan = useCallback(() => {}, []);

  const getGameCdkPolls = useCallback(() => {
    if (gamecdkQRcode?.data?.uuid) {
      dispatch(
        gameCdkPollsResult({
          uuid: gamecdkQRcode?.data?.uuid,
        }),
      );
    }
  }, [gamecdkQRcode]);

  const handleUpdate = useCallback(() => {
    setPageState(1);
    setPageTime(false);
    getGameCdkQRcode();
  }, []);

  const handleClose = useCallback(() => {
    // 关闭商城框
    dispatch(
      logging({
        category: 'C',
        action: 'Shop_Mall_Close',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      gameCDKSetVisible({
        isShow: false,
      }),
    );
  }, []);

  const handleIframeOrderOnLoad = useCallback(() => {
    logNative(`游戏cdk购买, 加载凤凰购买页面完成`);
  }, []);
  const handleIframeOrderOnError = useCallback(() => {
    setPageState(4);
    logNative(`游戏cdk购买, 加载凤凰购买页面失败`);
  }, []);

  const handleIframeCDKOnLoad = useCallback(() => {
    logNative(`游戏cdk购买, 加载凤凰兑换码页面完成`);
  }, []);
  const handleIframeCDKOnError = useCallback(() => {
    getGameCdkPolls();
    logNative(`游戏cdk购买, 加载凤凰兑换码页面失败`);
  }, [gamecdkQRcode]);

  const checkPage = useCallback(() => {
    if (
      loadRef &&
      orderRef &&
      codeRef &&
      errorRef &&
      loadRef?.current &&
      orderRef?.current &&
      codeRef?.current &&
      errorRef?.current
    ) {
      return true;
    }
    return false;
  }, [loadRef, orderRef, codeRef, errorRef]);

  const showPage = useCallback(
    page => {
      if (checkPage()) {
        changeClass(loadRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        changeClass(orderRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        changeClass(codeRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        changeClass(errorRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        let dom = loadRef?.current;
        page === 'load' && (dom = loadRef?.current);
        page === 'order' && (dom = orderRef?.current);
        page === 'code' && (dom = codeRef?.current);
        page === 'error' && (dom = errorRef?.current);
        setTimeout(() => {
          changeClass(dom, styles.gamecdk_page_in, styles.gamecdk_page_out);
        }, 0);
      }
    },
    [loadRef, orderRef, codeRef, errorRef],
  );

  if (!userInfo || !userInfo?.st) {
    return '';
  }
  return (
    <div className={styles.cdk_bg}>
      <div className={styles.cdk}>
        <div className={styles.cdk_header}>
          <div className={styles.cdk_header_title}>激活码购买</div>
          <div
            className={`${styles.cdk_header_close} iconfont icon-opt_close`}
            onClick={handleClose}
          ></div>
        </div>
        <div className={styles.cdk_body}>
          <div className={styles.cdk_load} ref={loadRef}>
            <div className={styles.cdk_loading}></div>
            <div className={styles.cdk_load_text}>激活码正在加速向你跑来...</div>
            <div className={styles.cdk_load_footer}>{gamecdkDesc?.description || ''}</div>
          </div>
          <div className={styles.cdk_order} ref={orderRef}>
            {gamecdkQRcode?.data?.url && (
              <iframe
                onLoad={handleIframeOrderOnLoad}
                onError={handleIframeOrderOnError}
                ref={iframeOrderRef}
                src={`${gamecdkQRcode?.data?.url || ''}`}
                style={{ width: '725px', height: '370px', border: 'none' }}
              />
            )}
          </div>
          <div className={styles.cdk_code} ref={codeRef}>
            {gamecdkPolls?.data?.exchangeUrl && (
              <iframe
                onLoad={handleIframeCDKOnLoad}
                onError={handleIframeCDKOnError}
                ref={iframeCodeRef}
                src={`${gamecdkPolls?.data?.exchangeUrl}`}
                style={{ width: '725px', height: '370px', border: 'none' }}
              />
            )}
          </div>
          <div className={styles.cdk_error} ref={errorRef}>
            <div className={styles.cdk_error_info}>
              <div className={`${styles.cdk_error_icon} iconfont icon-gcdk_error`}></div>
              <div className={styles.cdk_error_info_text}>激活码走丢了...</div>
            </div>
            <div className={styles.cdk_error_text}>
              {gamecdkQRcode?.message || '很抱歉，网络异常，请稍后再试'}
            </div>
            {gamecdkQRcode?.code === 531 ||
            gamecdkQRcode?.message === '很抱歉，网络异常，请稍后再试' ? (
              <div className={styles.cdk_error_btn} onClick={handleUpdate}>
                刷新
              </div>
            ) : (
              <div className={styles.cdk_error_btn_}></div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.cdk_order}></div>
    </div>
  );
});
